module.exports = __webpack_public_path__ + "static/media/spet_figura_2.5c178852.png";